import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getBanners = createAsyncThunk(
  'banner/getBanners',
  async ({ status }, { rejectWithValue }) => {
    try {
      const params = {};
      if (status) params.status = status;
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
        params,
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/banners/get-active-banners`,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          response: {
            data: {
              message: 'Network Error',
              status: err.code,
              statusText: err.code,
            },
          },
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || 'An error occurred'
        );
      }
    }
  }
);

export const addNewBanner = createAsyncThunk(
  'banner/addNewBanner',
  async (data, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('alt_text', data.alt_text);
      formData.append('file', data.file);
      formData.append('file_for_mobile', data.file_for_mobile);

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: true,
      };

      const response = await axios.post(
        `${PUBLIC_BASE_URL}/banners/create-banner`,
        formData,
        config
      );

      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          message: 'Network Error',
          status: err.code,
          success: false,
        });
      } else {
        return rejectWithValue(err.response?.data || 'Unknown error occurred.');
      }
    }
  }
);

export const removeBanner = createAsyncThunk(
  'banner/removeBanner',
  async (id, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      };

      const body = JSON.stringify(id);
      const response = await axios.put(
        `${PUBLIC_BASE_URL}/banners/remove-banner`,
        body,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          message: 'Network Error',
          status: err.code,
          success: false,
        });
      } else {
        return rejectWithValue(err.response?.data || 'Unknown error occurred.');
      }
    }
  }
);
